import { useEffect, useState } from 'react';
import { i18n } from 'next-i18next';

export const languagesToLoad = [
  'en',
  'es',
  'ru',
  'zh',
  'ar',
  'fr',
  'pt',
  'it',
  'tr',
  'pl',
  'ko',
  'ro',
  'el',
  'hu',
];

export const useAppI18n = () => {
  const [ready, setReady] = useState(false);

  const fetchTranslations = async (lng: string) => {
    // const response = await fetch(`/locales/${lng}/NAMESPACES.json`);
    const response = await fetch(`/api/i18n?hl=${lng}`);
    const data = await response.json();
    return data;
  };

  const loadLanguage = async (language: string) => {
    const res = await fetchTranslations(language);
    Object.entries(res.namespaces).forEach(([ns, data]) => {
      i18n!.addResourceBundle(language, ns, data);
    });
  };

  useEffect(() => {
    const loadDynamicData = async () => {
      const promises = languagesToLoad.map((language) => loadLanguage(language));
      await Promise.allSettled(promises);
      setReady(true);
    };

    loadDynamicData();
  }, []);

  return ready;
};
